import styled from "styled-components";
import bgHowItWorks from '../../Assets/bg_howItWorks.png'

export const Content = styled.div`
  width: 100%;
  position: relative;
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 1400px; 
  width: 100%;
  padding: 40px 16px;
  margin: 0 auto;
  margin-top: -1px;
  position: relative;

   @media (min-width:  1200px) {
    padding: 40px 120px;
   }
`

export const TextBox = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin-top: 90px;
 
  @media (min-width:  768px) {
    gap: 48px;
    justify-content: space-between;
  }
`

export const Title = styled.h1`
  font-size: 20px;
  font-style: normal;
  font-weight: 550;
  line-height: 28px;
  letter-spacing: 1px;
  color: var(--marine-25);
  max-width: 800px;

@media (min-width:  700px) {
  font-size: 26px;
  line-height: 34px;
}

@media (min-width:  1020px) {
  font-size: 32px;
  font-style: normal;
  line-height: 40px;
}
`

export const Text = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 325;
  line-height: 24px;
  letter-spacing: 1px;

@media (min-width:  700px) {
  font-size: 18px;
  font-style: normal;
  font-weight: 325;
  line-height: 28px;
}

@media (min-width:  1020px) {
  font-size: 20px;
  font-style: normal;
  font-weight: 325;
  line-height: 28px;
}
`

/* ===== Parallax wrapper com bolinhas iguais ao componente ===== */
export const WrapperParallaxBox = styled.div`
  position: relative;
  border-radius: 0;
  /* padding: 25px 0; */

  /* variáveis do pattern (iguais ao componente) */
  --gap: 8px;                 /* espaçamento da malha */
  --dot-size: 2px;            /* diâmetro visual da bolinha */
  --base-dot-opacity: 0.22;   /* opacidade das bolinhas */
  --mask-soft-vignette: linear-gradient(
    130deg,
    rgba(255, 255, 255, 0.18) 0%,
    rgba(255, 255, 255, 0.08) 40%,
    rgba(255, 255, 255, 0) 85%
  );

  @media (min-width: 1200px) {
    border-radius: 25%;
  }

  /* camada das bolinhas — pattern + vinheta suave */
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    pointer-events: none;

    /* bolinhas iguais ao componente (brancas com opacidade + vinheta sutil) */
    --dot-color: rgba(255, 255, 255, var(--base-dot-opacity));
    background-image:
      radial-gradient(
        circle at center,
        var(--dot-color) var(--dot-size),
        transparent calc(var(--dot-size) + 0.1px)
      ),
      var(--mask-soft-vignette);
    background-size:
      var(--gap) var(--gap),   /* tile da malha */
      100% 100%;
    background-repeat: repeat, no-repeat;
    background-position: 0 0, 0 0;

    /* mantém teu fade nas bordas */
    -webkit-mask-image: radial-gradient(
      circle at center,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 60%
    );
    mask-image: radial-gradient(
      circle at center,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 60%
    );
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;

    /* se quiser acender sobre fundo escuro:
       mix-blend-mode: screen; */
  }

  /* mantém teu fade/máscara nas bordas em telas médias+ */
  @media (min-width: 768px) {
    &::after {
      border-radius: 25%;

      /* fade nas laterais (radial) + topo e base (lineares) */
      -webkit-mask-image:
        radial-gradient(circle at center, #000 0%, transparent 60%),
        linear-gradient(to bottom, #000 75%, transparent 100%),
        linear-gradient(to top,    #000 75%, transparent 100%);
      -webkit-mask-repeat: no-repeat, no-repeat, no-repeat;
      -webkit-mask-composite: source-in, source-in;

      mask-image:
        radial-gradient(circle at center, #000 0%, transparent 60%),
        linear-gradient(to bottom, #000 75%, transparent 100%),
        linear-gradient(to top,    #000 75%, transparent 100%);
      mask-repeat: no-repeat, no-repeat, no-repeat;
      mask-composite: intersect, intersect;
    }
  }

`;

export const ParallaxBox = styled.div`
  display: none;
  position: relative;
  z-index: 1;
  margin: 0 auto;
  width: 100%;
  margin: 0 auto;
  background-position: top;
  background-repeat: no-repeat;
  background-image: url(${bgHowItWorks});
  overflow-y: auto;
  height: 85vh;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    height: fit-content;
   }

    @media (min-width: 768px) {
    display: block;
   }
`;

export const ParallaxMobileBox = styled.div`
  position: relative;
  z-index: 1;
  margin: 0 auto;
  width: 100%;
  margin: 0 auto;
  background-position: top;
  background-repeat: no-repeat;
  background-image: url(${bgHowItWorks});
  overflow-y: auto;
  height: 85vh;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    height: fit-content;
   }

   @media (min-width: 768px) {
    display: none;
   }
`;